import EditorMarkingRow from "../../../../components/foto/EditorMarkingRow";
import EditorSectionHeader from "../../../../components/common/EditorSectionHeader";

const TradoEditorFotoTrailerSection = (props) => {
  const { isBerangkat, showBerangkat, setShowBerangkat } = props;

  // props shared by every marking row
  const common = props;

  return (
    <>
      {/* FOTO TRAILER */}
      <EditorSectionHeader
        className="elevated-card-tight-vertical !bg-indigo-300 !px-4 !py-3 row-between-center w-full"
        title="FOTO TRAILER"
        isBerangkat={isBerangkat}
        showBerangkat={showBerangkat}
        setShowBerangkat={setShowBerangkat}
      />

      <EditorMarkingRow
        {...common}
        titleName="TAMPAK DEPAN TRAILER"
        labelGrup="gambar_box_depan"
      />
      <EditorMarkingRow
        {...common}
        titleName="TAMPAK BELAKANG TRAILER"
        labelGrup="gambar_box_belakang"
      />
      <EditorMarkingRow
        {...common}
        titleName="TAMPAK KIRI TRAILER"
        labelGrup="gambar_box_kiri"
      />
      <EditorMarkingRow
        {...common}
        titleName="TAMPAK KANAN TRAILER"
        labelGrup="gambar_box_kanan"
      />
    </>
  );
};

export default TradoEditorFotoTrailerSection;
